<template>
  <section-container>
    <header-page
      title_header="Adicionar nova Categoria"
      sub_header="Adicione nova categoria no catalogo da sua loja"
    />
    <content-e class="p-2">
      <div class="bg-white shadow-2l rounded p-6">
        <h2
          class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
        >
          Informações da Categoria
        </h2>
        <form
          action=""
          class="flex flex-wrap w-full"
          @submit.prevent="doStoreCategories"
          ref="formCategories"
        >
          <div class="w-full md:w-1/3 p-2" v-if="false">
            <image-preview-e :preview="previewImage"></image-preview-e>
          </div>
          <div class="w-full md:w-2/3 p-2 mx-auto">
            <div class="flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'tag', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="name"
                  label="Nome do produto:"
                ></input-icon>
              </div>
              <div class="w-full p-2">
                <label for="" class="text-sm mb-2">Descrição:</label>
                <quill-editor
                  class="rounded-lg"
                  ref="myQuillEditor"
                  v-model="description"
                  :options="editorOption"
                />
              </div>
              <div class="w-full p-2">
                <button-icon
                  icon="plus"
                  :text="
                    this.$route.params.category
                      ? `Atualizar Categoria`
                      : `Adicionar Categoria`
                  "
                  class="bg-indigo-600"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </content-e>
  </section-container>
</template>

<script>
export default {
  components: {},
  computed: {
    storeId() {
      return this.$store.state.store.id
    }
  },
  data() {
    return {
      name: '',
      previewImage: require('@/assets/img/photo_upload.png'),
      description: '',
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            ['clean'] // remove formatting button
          ]
        },
        placeholder: 'Descrição do categoria'
      }
    }
  },
  methods: {
    doShowCategory() {
      this.$store
        .dispatch('store/LOAD_CATEGORY_BY_ID', this.$route.params.category)
        .then((response) => {
          this.name = response.data.name
          this.description = response.data.description
        })
    },
    doStoreCategories() {
      const data = {
        store_id: this.storeId,
        name: this.name,
        description: this.description,
        slug: 'slug'
      }
      if (this.$route.params.category) {
        data.id = this.$route.params.category
      }
      this.$store
        .dispatch(
          `store/${
            this.$route.params.category
              ? 'UPDATE_CATEGORIES_BY_STORE'
              : 'CREATE_CATEGORIES_BY_STORE'
          }`,
          data
        )
        .then((response) => {
          this.$toasted.success(response.data.message, {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({
            name: 'store.category.index'
          })
        })
        .catch((error) => {
          const msg = Object.values(error.data.errors)
          msg.forEach((item, i) => {
            this.$toasted.error(item, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          })
        })
    }
  },
  beforeMount() {
    if (this.$route.params.category) {
      this.doShowCategory()
    }
  }
}
</script>

<style>
</style>
